<header class="pix-modal-header">
  <div>
    <span class="pix-kicker">CONTAS</span>
    <h2 id="pix-modal-title">Gerar Cobrança Pix</h2>
    <p>Selecione a conta.</p>
  </div>
  <button type="button" class="pix-fechar" aria-label="Fechar" (click)="fechar.emit()">×</button>
</header>

<div class="pix-modal-body">
  <section class="pix-config" *ngIf="!resultado">
    <label class="pix-label" for="pix-busca-conta">Conta</label>
    <input #buscaContaInput id="pix-busca-conta" class="ds-input" type="search" [(ngModel)]="buscaConta" (ngModelChange)="selecionarUnicaContaEncontrada()" (keydown.enter)="avancarParaValor($event)" placeholder="Buscar por cód., conta, banco ou empresa...">

    <div class="pix-contas-lista" role="listbox" aria-label="Contas disponíveis">
      <button *ngFor="let conta of contasFiltradas" type="button" class="pix-conta-opcao"
              [class.pix-conta-opcao--ativa]="contaSelecionada?.codigoInterno === conta.codigoInterno"
              (click)="selecionarConta(conta)">
        <span class="pix-conta-codigo" aria-label="Código da conta">{{ conta.codigoInterno || '-' }}</span>
        <span class="pix-conta-conteudo">
          <span class="pix-conta-principal">{{ conta.descricao || conta.conta || 'Conta sem descrição' }}</span>
          <span class="pix-conta-detalhe">Conta {{ conta.conta || '-' }} · {{ conta.banco || conta.codigoBanco || 'Banco não informado' }} · {{ conta.empresa || 'Empresa não informada' }}</span>
        </span>
      </button>
      <p class="pix-vazio" *ngIf="!contasFiltradas.length">Nenhuma conta corresponde à busca.</p>
    </div>

    <label class="pix-label" for="pix-valor">Valor da cobrança (opcional)</label>
    <div class="pix-valor-wrap">
      <span>R$</span>
      <input #valorPixInput id="pix-valor" class="ds-input" type="text" inputmode="decimal" appMoneyMask [(ngModel)]="valor" (keydown.enter)="gerarComEnter($event)" placeholder="0,00" autocomplete="off">
    </div>
    <p class="pix-selecionada">Deixe vazio ou informe 0,00 para o cliente digitar o valor no app do banco.</p>
    <p class="pix-selecionada" *ngIf="contaSelecionada">Conta selecionada: <strong>{{ contaSelecionada.descricao || contaSelecionada.conta }}</strong></p>
    <div class="pix-erro" *ngIf="erro">
      <span>{{ erro }}</span>
      <button type="button" class="pix-tentar" (click)="tentarNovamente()" [disabled]="gerando">Tentar novamente</button>
    </div>
  </section>

  <section class="pix-resultado" *ngIf="resultado">
    <div class="pix-resultado-grid">
      <div class="pix-imagem-coluna">
        <div class="pix-retrato" #pixRetrato>
          <div class="pix-qr-wrap" *ngIf="campoPix('imagem') as imagem; else qrIndisponivel">
            <img [src]="imagem" alt="QR Code Pix" (load)="lerConteudoQr($event)">
          </div>
          <ng-template #qrIndisponivel><div class="pix-qr-indisponivel">QR Code indispon&#237;vel</div></ng-template>
          <div class="pix-banco-dados">
            <strong class="pix-banco-titulo">
              <img class="pix-bank-icon" [src]="iconeBanco()" alt="" aria-hidden="true">
              <span>{{ campoPix('deposito', 'favorecido') || contaSelecionada?.banco || 'Cobran&#231;a Pix' }}</span>
            </strong>
            <span>AG. {{ campoPix('conta') || contaSelecionada?.conta || '-' }}</span>
            <span>Favorecido: {{ campoPix('favorecido') || contaSelecionada?.empresa || '-' }}</span>
          </div>
          <div class="pix-valor-gerado" *ngIf="valorAberto">Valor: <strong>informado pelo pagador</strong></div>
          <div class="pix-valor-gerado" *ngIf="!valorAberto">Valor: <strong>{{ valorFormatado() }}</strong></div>
          <div class="pix-chave">Chave Pix: <strong>{{ campoPix('pix', 'chavePix', 'CHAVEPIX') || '-' }}</strong></div>
        </div>
      </div>

      <div class="pix-copia-coluna">
        <label class="pix-label" for="pix-copia-cola">Copia e cola</label>
        <p class="pix-leitura" *ngIf="qrDecodificando">Lendo o conte&#250;do do QR Code...</p>
        <div class="pix-copia-wrap">
          <textarea id="pix-copia-cola" class="pix-copia" readonly [value]="copiaECola()"></textarea>
          <button type="button" class="pix-copiar" [disabled]="!copiaECola()" (click)="copiarCopiaECola()">{{ copiado ? 'Copiado' : 'Copiar' }}</button>
        </div>
        <div class="pix-acoes-secundarias">
          <button type="button" class="pix-imagem" [disabled]="gerandoImagem" (click)="baixarImagemPix()">
            {{ gerandoImagem ? 'Gerando imagem...' : 'Baixar imagem Pix' }}
          </button>
          <button type="button" class="pix-whatsapp" [disabled]="!copiaECola()" (click)="enviarPorWhatsapp()">Enviar por WhatsApp</button>
        </div>
        <div class="pix-erro" *ngIf="erro">{{ erro }}</div>
      </div>
    </div>
  </section>
</div>

<footer class="pix-modal-footer">
  <button type="button" class="bt-cancelar" (click)="fechar.emit()">Fechar</button>
  <button *ngIf="!resultado" type="button" class="bt-salvar pix-gerar" (click)="gerar()" [disabled]="gerando">
    <app-loading-indicator *ngIf="gerando" size="inline"></app-loading-indicator>{{ gerando ? 'Gerando...' : 'Gerar cobrança' }}
  </button>
  <button *ngIf="resultado" type="button" class="bt-salvar" (click)="resultado = null; copiado = false; copiaColaReal = ''">Gerar outra</button>
</footer>
